import React, { useState } from 'react';
import Joi from 'joi';
import Services from '../service/Services'
import { toast } from 'react-toastify';
import Spinner from '../components/Spinner';
import image from '../photos/backg.jpg';
import { useNavigate } from 'react-router-dom';

const loginSchema = Joi.object({
    email: Joi.string()
        .trim()
        .required()
        .messages({
            'string.empty': 'Enter the Email',
            'any.required': 'Enter the Email',
        }),
    password: Joi.string()
        .required()
        .messages({
            'string.empty': 'Enter the Password',
            'any.required': 'Enter the Password',
        }),
});

const validateLogin = (values) => {
    const { error } = loginSchema.validate(values, { abortEarly: false });
    if (!error) return null;
    return error.details.reduce((acc, detail) => {
        const field = detail.path[0];
        if (!acc[field]) acc[field] = detail.message;
        return acc;
    }, {});
};

export default function LoginForm() {
    const navigate = useNavigate()
    // const alert = useAlert();
    const [loading, setLoading] = useState(false)
    const [email, setEmail] = useState("")
    const [password, setPassword] = useState("")

    const [emailError, setEmailError ] = useState("")
    const [PassError, setPassError ] = useState("")
    const handlesubmit = (e) =>{
        e.preventDefault();
        const errors = validateLogin({ email, password });
        setEmailError(errors?.email || "");
        setPassError(errors?.password || "");

        if(errors){
            return;
        }else{
            const data = {
                userName:email,
                password:password
            };
            setLoading(true)
            Services.Common.login(data).then(function(result) {
                if(result.success === true){
                    //console.log(result.data)
                localStorage.setItem("token",result.data);
                toast.success(result.message);
                setLoading(false)
               navigate("/");
                }else{
                    toast.error(result.message);
                    setLoading(false)
                }
            });
        }
    };
  return (
    <div className="flex flex-col items-center min-h-screen pt-6 sm:justify-center sm:pt-0 bg-gray-50" style={{backgroundImage:`url(${image})`}}>
    {loading && <Spinner />}
        <div>
        <div className="flex justify-center">
  <img
    src="/zimage1.png"
    alt="Logo"
    style={{ width: '400px', height: '70px' }} // ✅ Set your desired size
  />
</div>


            {/* <h3 className="text-4xl font-bold text-white">
                <span style={{fontSize:'18px',textAlign:'center',marginLeft: '67px'}}>(Quotation System)</span>
            </h3> */}
        </div>
        <div className="w-full px-6 py-4 mt-6 overflow-hidden bg-white shadow-md sm:max-w-md sm:rounded-lg">
            <form onSubmit={handlesubmit}>
                <div className="mt-4">
                    <label
                        htmlFor="email" className="block text-sm font-medium text-gray-700 undefined">
                        Email<span className="text-red-500">&nbsp;*</span>
                    </label>
                    <div className="flex flex-col items-start">
                        <input
                            type="text"
                            name="email"
                            onChange={(e)=>{
                                setEmail(e.target.value);
                                if (emailError) setEmailError("");
                            }}
                            className="block w-full mt-1 border-gray-300 rounded-md shadow-sm focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50"
                        />
                    </div>
                    <div className='text-red-500 text-sm'>{emailError}</div>
                </div>
                <div className="mt-4">
                    <label htmlFor="password" className="block text-sm font-medium text-gray-700 undefined">
                        Password<span className="text-red-500">&nbsp;*</span>
                    </label>
                    <div className="flex flex-col items-start">
                        <input
                            type="password"
                            name='password'
                            onChange={(e)=>{
                                setPassword(e.target.value);
                                if (PassError) setPassError("");
                            }}
                            className="block w-full mt-1 border-gray-300 rounded-md shadow-sm focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50"
                        />
                    </div>
                    <div className='text-red-500 text-sm'>{PassError}</div>
                </div>
                <div className="flex items-center justify-end mt-4">
                    <button type="submit" className="inline-flex items-center px-4 py-2 ml-4 text-xs font-semibold tracking-widest text-white uppercase transition duration-150 ease-in-out bg-red-900 border border-transparent rounded-md active:bg-red-600 false">
                        Login
                    </button>
                </div>
            </form>
        </div>
    </div>
  )
}
